export default function Form(props) {
  const {onSubmit} = props;

  return(
    <form className={props.className} onSubmit={onSubmit}>
      {props.children}
    </form>
  );
};
